import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';

interface UserToken {
  userId: string;
  email: string;
  googleRefreshToken: string;
}

@Component({
  selector: 'hour4u-admin-google-account-popup',
  templateUrl: './google-account-popup.component.html',
  styleUrls: ['./google-account-popup.component.scss']
})
export class GoogleAccountPopupComponent implements OnInit {
  isLoading: boolean = false;
  profile = this.appService.getCurrentAccount();

  constructor(
    public dialogRef: MatDialogRef<GoogleAccountPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private jobService: JobService,
  ) { }

  ngOnInit() {
    console.log(this.data)
  }

  async selectExistingAccount(account: UserToken) {
    this.dialogRef.close(account);
  }

  useNewAccount() {
    this.dialogRef.close(true);
  }
}
